import Mutations from '../../odata/mutations';

export default { ...new Mutations('impression'), ...new Mutations('impressions') };
